import { render, staticRenderFns } from "./AzconTrainingCard.vue?vue&type=template&id=56b849d8&scoped=true"
import script from "./AzconTrainingCard.vue?vue&type=script&lang=js"
export * from "./AzconTrainingCard.vue?vue&type=script&lang=js"
import style0 from "./AzconTrainingCard.vue?vue&type=style&index=0&id=56b849d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b849d8",
  null
  
)

export default component.exports